/**
 * Error Boundary — глобальная обработка ошибок в React tree.
 * Ловит ошибки в компонентах и показывает fallback UI вместо белого экрана.
 */
import { Component, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            padding: "24px",
            fontFamily: "sans-serif",
            textAlign: "center",
          }}
        >
          <div>
            <h1 style={{ color: "#AB2B2B", marginBottom: "16px" }}>
              Ошибка приложения
            </h1>
            <p style={{ color: "#666", marginBottom: "24px" }}>
              {this.state.error?.message || "Неизвестная ошибка"}
            </p>
            <details
              style={{
                textAlign: "left",
                maxWidth: "500px",
                margin: "0 auto 24px",
                padding: "12px",
                background: "#f5f5f5",
                borderRadius: "4px",
              }}
            >
              <summary style={{ cursor: "pointer", fontWeight: "500" }}>
                Детали ошибки
              </summary>
              <pre
                style={{
                  fontSize: "12px",
                  overflow: "auto",
                  marginTop: "8px",
                }}
              >
                {this.state.error?.stack || "нет стека"}
              </pre>
            </details>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "10px 20px",
                background: "#AB2B2B",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Перезагрузить приложение
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
